import { type ChangeEvent, type FC, type ReactNode } from 'react';
import { useIntl, defineMessages } from 'dibs-react-intl';
import { graphql, useFragment } from 'react-relay';

import { BasicSelect } from 'dibs-elements/exports/BasicSelect.tsx';

import fieldNames from '../../data/sellerApplicationFieldNames.json' with { type: 'json' };

import { type Country_geographySalesforce$key } from './__generated__/Country_geographySalesforce.graphql.ts';

type Props = {
    errorMessage: ReactNode;
    value: string;
    onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
    geographySalesforce: Country_geographySalesforce$key | null | undefined;
    disabled?: boolean;
};

const messages = defineMessages({
    country: {
        id: 'DealerApplicationForm.country.placeholder',
        defaultMessage: 'Country',
    },
});

const Country: FC<Props> = ({
    errorMessage,
    value,
    disabled,
    onChange,
    geographySalesforce: geographySalesforceRef,
}) => {
    const intl = useIntl();

    const geographySalesforce = useFragment(
        graphql`
            fragment Country_geographySalesforce on GeographySalesforce {
                countries {
                    name
                    abbreviation
                }
            }
        `,
        geographySalesforceRef
    );

    const countriesOptions = (geographySalesforce?.countries || []).map(sfCountry => ({
        label: sfCountry?.name || '',
        value: sfCountry?.abbreviation || '',
    }));

    return (
        <BasicSelect
            dataTn="address-country"
            name={fieldNames.dealerInfo.country}
            placeholder={intl.formatMessage(messages.country)}
            hasAnimatedPlaceholder
            autoComplete="country"
            options={countriesOptions}
            onChange={onChange}
            errorMessage={errorMessage}
            hasError={!!errorMessage}
            disabled={disabled}
            value={value}
        />
    );
};

export default Country;
